import { Navigate } from 'react-router-dom';
import { useEventForm } from '../context/EventFormContext';
import logger from '../utils/logger';

/**
 * RouteGuard Component
 * Protects form-flow routes by checking prerequisite data in context.
 * Redirects to the earliest incomplete step when requirements are not met.
 */
export default function RouteGuard({ children, requiredData }) {
  const { formData } = useEventForm();
  const setScene = formData?.setScene || {};

  const redirect = (reason, to) => {
    logger.warning('Route guard redirect', { from: window.location.pathname, reason });
    return <Navigate to={to} replace />;
  };

  if (requiredData === '/details') {
    if (!setScene.occasion) return redirect('Missing occasion', '/');
  }

  if (requiredData === '/dream') {
    if (!setScene.occasion) return redirect('Missing occasion', '/');
    if (!setScene.activity || !setScene.guestCount || !setScene.budget || !setScene.date || !setScene.startTime || !setScene.duration) {
      return redirect('Incomplete event details', '/details');
    }
  }

  if (requiredData === '/inspiration') {
    if (!setScene.occasion) return redirect('Missing occasion', '/');
    if (!formData?.dream) return redirect('Missing dream description', '/dream');
  }

  if (requiredData === '/contact') {
    if (!setScene.occasion) return redirect('Missing occasion', '/');
    if (!setScene.activity || !setScene.guestCount || !setScene.budget || !setScene.date || !setScene.startTime || !setScene.duration) {
      return redirect('Incomplete event details', '/details');
    }
    if (!formData?.dream) return redirect('Missing dream description', '/dream');
  }

  if (requiredData === '/submission-success') {
    if (!formData?.contact) return redirect('Missing contact info', '/contact');
  }

  return children;
}